<template>
    <div class="overview">
        <h1 class="title">
            Thanks to the following people for making this happen
        </h1>

        <div class="content">
            <div class="groups">
                <div class="group" :class="group.class" v-for="(group, index) in thankspeople" :key="index">
                    <h3 class="group-title">{{group.name}}</h3>
                    <p class="group-person" v-for="(person, index) in group.people" :key="index">{{person}}</p>
                </div>

                <div class="thanks">
                    <img :src="images.heart"/> <br/>
                    <h3>Thank you everyone for making 2017 amazing!</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import heartImage from '../../assets/images/Shout Outs/heart.png';

    export default {
        data: function () {
            return {
                images: {
                    heart: heartImage
                },

                thankspeople: [
                    {
                        name: 'Graduate Bootcamp',
                        class: 'bootcamp',
                        people: [
                            'Ahmad Mahomed',
                            'Gail Shaw',
                            'Gregory Schroder',
                            'Jacques Du Preez',
                            'Matt van der Westhuizen',
                            'Matthew van der Velden',
                            'Rishal Hurbans',
                            'Sharon Salomon',
                        ]
                    },
                    {
                        name: 'Dev Day',
                        class: 'dev-day',
                        people: [
                            'Gregory Schroder',
                            'James Gezane',
                            'Janine Lodewick',
                            'Rishal Hurbans',
                            'Sheldon Lyne',
                            'Tinus van den Heever',
                            'Tristan Goring',
                            'Velice Naumoski',
                            'Warren Bonn',
                        ]
                    },
                    {
                        name: 'Tech Accelerator',
                        class: 'tech-accelerator',
                        people: [
                            'Andrew Parkes',
                            'Calvin Nefdt',
                            'Gregory Schroder',
                            'James Murray',
                            'Mark Garber',
                            'Portia Gibbs',
                            'Rishal Hurbans',
                            'Sheldon Lyne',
                            'Stephen Scott',
                            'Tristan Goring',
                        ]
                    },
                    {
                        name: 'Tech Clubs',
                        class: 'tech-clubs',
                        people: [
                            'Mark Beets',
                            'Matt van der Westhuizen',
                            'Richard O\'Brien',
                            'Sas van der Westhuizen',
                        ]
                    },
                    {
                        name: 'Awesome Support',
                        class: 'awesome-support',
                        people: [
                            'Christine van der Walt',
                            'Christos Zachos',
                            'James Gezane',
                            'Portia Gibbs',
                            'Sheldon Lyne',
                            'Tanya Le Roux',
                            'Warren Bonn',
                        ]
                    },
                    {
                        name: 'Entelect Challenge',
                        class: 'entelect-challenge',
                        people: [
                            'Edwin Fullard',
                            'Eric Louw',
                            'Gerhard Smit',
                            'Hennie Brink',
                            'Madene Marais',
                            'Portia Gibbs',
                            'Rishal Hurbans',
                            'Sas van der Westhuizen',
                            'Tomislav Ravic',
                        ]
                    },
                    {
                        name: 'Tech Community Facilitators',
                        class: 'tech-community-facilitators',
                        people: [
                            'Christoff Smith',
                            'Christopher Araujo',
                            'Chris Nezar',
                            'David Weatherhead',
                            'Duncan Gillies',
                            'Enrique Geldenhuys',
                            'Gail Shaw',
                            'Hendrik Kolver',
                            'Hennie Brink',
                            'Marius Kruger',
                            'Mark Beets',
                            'Matthew Longden',
                            'Matthew Winter',
                            'Portia Gibbs',
                            'Privolin Naidoo',
                            'Rishal Hurbans',
                            'Rowan Deysel',
                            'Ryan Naude',
                            'Sahil Naran',
                            'Sheldon Lyne',
                            'Timothy Lewis',
                            'Wahjid Nasser',
                        ]
                    },
                    {
                        name: 'Girl Code',
                        class: 'girl-code',
                        people: [
                            'Aimee Nortje',
                            'Desere Kruger',
                            'Gertruida Maritz',
                            'Kumashree Naidoo',
                            'Magdalena Leisegang',
                            'Portia Gibbs',
                            'Samantha Winfield',
                        ]
                    },
                    {
                        name: 'Life Long Learning Facilitators',
                        class: 'life-long-learning-facilitators',
                        people: [
                            'Duane McKibbin',
                            'Grant Marais',
                            'Gregory Schroder',
                            'Hennie Brink',
                            'Matt van der Westhuizen',
                            'Rishal Hurbans',
                            'Wahjid Nasser',
                        ]
                    },
                    {
                        name: 'Retrospectives site',
                        class: 'retrospectives-site',
                        people: [
                            'Chris Snyders',
                            'Daan Keun',
                            'Edwin Fullard',
                            'Gail Shaw',
                            'Rishal Hurbans',
                            'Wayne Winter',
                        ]
                    },
                    {
                        name: 'Funding and Moral Support',
                        class: 'funding-and-moral-support',
                        people: [
                            'Shashi Hansjee',
                            'Sheldon Lyne',
                        ]
                    },
                ]
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/shoutouts') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overview {
        display: grid;
        grid-template-areas: 'title title title' 'content content content';
        grid-auto-flow: column;
        color: white;

        .title {
            grid-area: title;
            align-self: start;
            justify-self: center;
            text-align: center;
            margin: 24px;
            display: grid;
            align-content: center;
            justify-content: center;
        }

        .content {
            display: grid;
            grid-area: content;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 32px;
            padding-bottom: 24px;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 2fr 2fr 1fr;
            }

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-columns: 1fr 3fr 3fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-columns: 32px 1fr 32px;
                grid-gap: 0;
            }

            .groups {
                grid-column: 2 / span 2;

                display: grid;
                grid-gap: 16px;
                grid-template-columns: 1fr 1fr 1fr;
                grid-template-areas:
                        'techclubs   bootcamp  facilitators'
                        'devday      support   facilitators'
                        'accelerator challenge girlcode'
                        'learning    site      funding'
                        'thanks      thanks    thanks';

                @media only screen and (max-width: $screen-md-max) {
                    grid-template-columns: 1fr 1fr;
                    grid-template-areas:
                            'facilitators   techclubs'
                            'facilitators   support'
                            'facilitators   girlcode'
                            'bootcamp       challenge'
                            'accelerator    devday'
                            'learning       site'
                            'funding        .'
                            'thanks         thanks';
                }

                @media only screen and (max-width: $screen-xs-max) {
                    grid-column: 2;

                    grid-template-columns: 1fr;
                    grid-template-areas:
                            'techclubs'
                            'support'
                            'girlcode'
                            'facilitators'
                            'bootcamp'
                            'challenge'
                            'accelerator'
                            'devday'
                            'learning'
                            'site'
                            'funding'
                            'thanks';
                }

                .group {
                    &.bootcamp {
                        grid-area: bootcamp;
                    }

                    &.dev-day {
                        grid-area: devday;
                    }

                    &.tech-accelerator {
                        grid-area: accelerator;
                    }

                    &.tech-clubs {
                        grid-area: techclubs;
                    }

                    &.awesome-support {
                        grid-area: support;
                    }

                    &.entelect-challenge {
                        grid-area: challenge;
                    }

                    &.tech-community-facilitators {
                        grid-area: facilitators;
                    }

                    &.girl-code {
                        grid-area: girlcode;
                    }

                    &.life-long-learning-facilitators {
                        grid-area: learning;
                    }

                    &.retrospectives-site {
                        grid-area: site;
                    }

                    &.funding-and-moral-support {
                        grid-area: funding;
                    }

                    .group-title {
                        margin-bottom: 4px;
                        color: $green;
                    }
                }

                .thanks {
                    grid-area: thanks;
                    display: grid;
                    grid-template-rows: 50px auto;
                    align-items: center;
                    justify-items: center;
                    text-align: center;
                    color: $entelect-orange;

                    img {
                        height: 100%;
                    }
                }
            }
        }
    }

</style>
